<template>
<div>
  <v-dialog v-model="bDialog"  max-width="600px" persistent>
    <v-card flat tile ref="form">
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="font-weight-bold">
          <v-icon class="mr-2">search</v-icon>ID/PW/소속 검색하기
        </v-toolbar-title>
      </v-toolbar>
      <v-divider class="ml-2 mr-2"></v-divider>

      <v-tabs class="mt-4" v-model="iModel" @change="Clear()">
        <v-tab center-active class="ml-4 text-subtitle-1 font-weight-bold"><v-icon class="mr-3">mdi-shield-account</v-icon> ID 찾기 </v-tab>
        <v-tab center-active class="ml-4 text-subtitle-1 font-weight-bold"><v-icon class="mr-3">mdi-account-key</v-icon> PW 찾기 </v-tab>
        <v-tab center-active class="ml-4 text-subtitle-1 font-weight-bold"><v-icon class="mr-3">mdi-office-building-marker</v-icon> 소속기업 찾기 </v-tab>
      </v-tabs>
      <v-divider class="ml-2 mr-2"></v-divider>

      <v-card-text class="pr-4 pl-4 pb-6 mt-6">
        <div v-show="iModel == 0">
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field @click:append-outer="SearchCorp()" @keyup.enter="SearchCorp()" v-model="editedItem.cCorpNm" @keyup="editedItem.cCorpId = ''" append-outer-icon="search" dense class="mb-n2">
                <template v-slot:label>
                  <div>회사명<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6"></v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field v-model="editedItem.cCustomNm" hint="띄어쓰기 없이 입력하세요." dense class="mb-n2" ref="cCustomNmRef1">
                <template v-slot:label>
                  <div>성명<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field v-model="editedItem.cBirth" placeholder="YYYYMMDD" dense class="mb-n2" type="number" maxlength="10">
                <template v-slot:label>
                  <div>생년월일<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" align="center">
              <v-divider class="mb-0 mt-0"></v-divider>
              <div class="d-flex mt-2">
                <v-card-subtitle class="font-weight-bold subtitle-2 pa-2">검색결과</v-card-subtitle>
                <v-spacer></v-spacer>
                <v-btn @click="SearchCustomId()" width="100px" text><v-icon class="mr-1">search</v-icon>검색</v-btn>
              </div>
              <v-data-table 
                :items-per-page="-1" 
                fixed-header
                hide-default-header
                hide-default-footer
                :headers="headers1" 
                :items="Records1"
                :no-data-text="sNoMsg"
              >
                <template v-slot:item.cCustomNickId="{ item }">
                  아이디 : {{item.cCustomNickId}}
                </template>
                <!-- <template v-slot:no-data>
                  <div clasa="dark--text">검색결과가 없습니다.</div>
                </template> -->
              </v-data-table>
            </v-col>
          </v-row>
        </div>

        <div v-show="iModel == 1">            
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field v-model="editedItem.cCorpNm" @click:append-outer="SearchCorp()" @keyup.enter="SearchCorp()" @keyup="editedItem.cCorpId = ''" append-outer-icon="search" dense class="mb-n2">
                <template v-slot:label>
                  <div>회사명<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6"></v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2" v-model="editedItem.cCustomNm" hint="띄어쓰기없이 없이 입력하세요." ref="cCustomNmRef2">
                <template v-slot:label>
                  <div>성명<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field v-model="editedItem.cBirth" placeholder="YYYYMMDD" dense class="mb-n2" type="number" maxlength="10">
                <template v-slot:label>
                  <div>생년월일<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2" v-model="editedItem.cCustomNickId">
                <template v-slot:label>
                  <div>아이디<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense v-model="editedItem.cTel" hint="'-'는 없이 입력하세요." @keyup.enter="SearchCustomPW()" @click:append-outer="SearchCustomPW()" append-outer-icon="send">
                <template v-slot:label>
                  <div>휴대전화<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
              <div class="text-caption">* 입력하신 번호로 신규비밀번호가 발송됩니다.</div>
            </v-col>
          </v-row>
        </div>

        <div v-show="iModel == 2">
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2" v-model="editedItem.cCustomNm">
                <template v-slot:label>
                  <div>성명<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field v-model="editedItem.cBirth" placeholder="YYYYMMDD" dense class="mb-n2" type="number" maxlength="10">
                <template v-slot:label>
                  <div>생년월일<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2" v-model="editedItem.cTel" hint="'-'는 없이 입력하세요.">
                <template v-slot:label>
                  <div>휴대전화<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
              <div class="text-caption mt-4">* 등록시 입력한 휴대전화 번호를 입력하세요.</div>
            </v-col>
            <v-col cols="12" sm="12" md="12" align="right">
              <v-divider class="mt-2 mb-2"></v-divider>
              <div class="d-flex mt-2">
                <v-card-subtitle class="font-weight-bold subtitle-2 pa-2">검색결과</v-card-subtitle>
                <v-spacer></v-spacer>
                <v-btn @click="SearchCustomCorp()" width="100px" text><v-icon class="mr-1">search</v-icon>검색</v-btn>
              </div>
              <v-data-table
                :items-per-page="-1" 
                fixed-header
                hide-default-header
                hide-default-footer
                :headers="headers3" 
                :items="Records3"
                :no-data-text="sNoMsg"
              >
                <template v-slot:item.cCorpNmKor="{ item }">
                  <div v-if="item.cLocal == 'Y'">{{item.cCorpNmKor}}</div>
                  <div v-else>{{item.cCorpNmEng}}</div>
                  <!-- 업체명 : {{item.cCorpNmKor}} -->
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </div>
      </v-card-text>

      <v-card-text align="right" class="pa-3 pt-0">
        <v-divider class="mb-2 mt-2"></v-divider>
        <v-btn @click="Close()" width="100px" dark class="ml-2"><v-icon class="mr-1">mdi-close</v-icon>닫기</v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>

  <SearchCorp ref="SearchCorpRef" @GetCorpInfo="GetCorpInfo"/>
</div>
</template>

<script>
import BasicInfo from "../BasicInfo.js";
import axios from "axios"
import EventBus from '@/eventBus.js';
// import SearchCorp from "./SearchCorp.vue";
import SearchCorp from "./SearchCorp.vue";
import Util from "../Util.js";

export default {
  components: {
    SearchCorp,
  },
  data: () => ({
    bDialog : false,
    iModel : 0,
    bBirthcheck : false,
    sNoMsg : "검색결과가 없습니다.",

    headers1: [
      { class: "font-weight-bold subtitle-2", text: "검색결과", value: "cCustomNickId", align: "center"},
    ],
    headers2: [
      { class: "font-weight-bold subtitle-2", text: "검색결과", value: "cRes", align: "center"},
    ],
    headers3: [
      { class: "font-weight-bold subtitle-2", text: "검색결과", value: "cCorpNmKor", align: "center"},
    ],
    Records1: [],
    // Records2: [],
    Records3: [],

    editedItem: {
      cCustomNickId : "",
      cCustomNm : "",
      cPwd : "",
      cRePwd : "",
      cEmail : "",
      cTel : "",
      cBirth: "",
      cLevNm : "",
      cCorpId : "",
      cCorpNm : "",
      cPartId : "",
      cPledge1 : "",
      cPledge2 : "",
      cPledge3 : "",
      cPledge4 : "",
      cPledge5 : "",
      cPledge6 : "",
      cFileId : "",
      cPwdFailCnt : 0,
      cLocked : "N",
      cUse: "Y",
      cCreateDateTime: "",
      cUpdateDateTime: "",
    },
    defaultItem: {
      cCustomNickId : "",
      cCustomNm : "",
      cPwd : "",
      cRePwd : "",
      cEmail : "",
      cTel : "",
      cBirth: "",
      cLevNm : "",
      cCorpId : "",
      cCorpNm : "",
      cPartId : "",
      cPledge1 : "",
      cPledge2 : "",
      cPledge3 : "",
      cPledge4 : "",
      cPledge5 : "",
      cPledge6 : "",
      cFileId : "",
      cPwdFailCnt : 0,
      cLocked : "N",
      cUse: "Y",
      cCreateDateTime: "",
      cUpdateDateTime: "",
    },
  }),
      
  computed: {  
  },
  
  created() {
    this.Initialize();
  },

  methods: {
    // 페이지 열기
    Open() {
      this.bDialog = true;
      this.Initialize();
      this.editedItem = Object.assign({}, this.defaultItem);
    },

    Initialize() {
      this.iModel = 0;
    },

    SearchCustomId() {
      if (this.editedItem.cCorpId == "" ) {
        EventBus.$emit("onShowMsgBox","회사명이 입력되지 않았습니다.", "회사명은 필수입력 항목입니다.");
        return;
      }
      if (this.editedItem.cCustomNm == "" ) {
        EventBus.$emit("onShowMsgBox","성명이 입력되지 않았습니다.", "성명은 필수입력 항목입니다.");
        return;
      }

      if (!this.CheckBirth()) {
        return;
      }

      var posData = {
        cCorpId : this.editedItem.cCorpId,
        cCustomNm : this.editedItem.cCustomNm,
        cBirth : Util.sTenLenghtDate(this.editedItem.cBirth),
      };

      axios
        .post(BasicInfo.UIL_API + "SearchCustomId", posData, {
          headers: {}
        })
        .then(res => {
          if (res.data.ResultCd === "00") {
            this.Records1 = res.data.Result;
            if (this.Records1.length == 0) {
              this.sNoMsg = ""
              setTimeout(() => {
                this.Records1 = [];
                this.sNoMsg = "검색결과가 없습니다."
              }, 500);
            }  
          } else {
            EventBus.$emit("onShowMsg", true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg", true,""+err);
        });
    },

    // PW 찾기
    SearchCustomPW() {
      this.editedItem.cCustomNickId = Util.RemoveBlank(this.editedItem.cCustomNickId)
      if (this.editedItem.cCorpId == "" ) {
        EventBus.$emit("onShowMsgBox","회사명이 입력되지 않았습니다.", "회사명은 필수입력 항목입니다.");
        return;
      }
      if (this.editedItem.cCustomNm == "" ) {
        EventBus.$emit("onShowMsgBox","성명이 입력되지 않았습니다.", "성명은 필수입력 항목입니다.");
        return;
      }

      if (!this.CheckBirth()) {
        return;
      }

      if (this.editedItem.cCustomNickId == "" ) {
        EventBus.$emit("onShowMsgBox","아이디가 입력되지 않았습니다.", "아이디는 필수입력 항목입니다.");
        return;
      }
      if (!/^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/.test(this.editedItem.cTel)) {
        EventBus.$emit("onShowMsgBox","휴대전화 번호 형식이 올바르지 않습니다.", "['-' 제외하고 숫자만 입력해주세요.]");
        return;
      }

      var posData = {
        cCorpId : this.editedItem.cCorpId,
        cCustomNm : this.editedItem.cCustomNm,
        cBirth : Util.sTenLenghtDate(this.editedItem.cBirth),
        cCustomNickId : this.editedItem.cCustomNickId,
        cTel : this.editedItem.cTel,
      };

      axios
        .post(BasicInfo.UIL_API + "SearchCustomPW", posData, {
          headers: {}
        })
        .then(res => {
          if (res.data.ResultCd === "00") {
            this.bDialog = false;
            EventBus.$emit("onShowMsg",false,"신규비밀번호가 고객님의 전화번호로 발송되었습니다.");
          } else if (res.data.ResultCd === "02") {
            EventBus.$emit("onShowMsgBox","삭제되었거나 없는 아이디 입니다.", "아이디를 다시 확인하여 주세요.");
          } else {
            EventBus.$emit("onShowMsg", true,"( "+res.data.ResultCd+" )"+res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg", true,""+err);
        });
    },

    // 소속 찾기
    SearchCustomCorp() {
      if (this.editedItem.cCustomNm == "" ) {
        EventBus.$emit("onShowMsgBox","성명 항목을 확인하여 주세요.", "성명은 필수입력 항목입니다.");
        return;
      }

      if (!this.CheckBirth()) {
        return;
      }

      if (!/^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/.test(this.editedItem.cTel)) {
        EventBus.$emit("onShowMsgBox","휴대전화 형식이 올바르지 않습니다.", "['-' 제외하고 숫자만 입력해주세요.]");
        return;
      }
      var posData = {
        cCustomNm : this.editedItem.cCustomNm,
        cBirth : Util.sTenLenghtDate(this.editedItem.cBirth),
        cTel : this.editedItem.cTel,
      };
      axios
        .post(BasicInfo.UIL_API + "SearchCustomCorp", posData, {
          headers: {
            //"Authorization": this.$store.state.UserInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd === "00") {   
            this.Records3 = res.data.Result;           
            if (this.Records3.length == 0) {
              this.sNoMsg = ""
              setTimeout(() => {
                this.sNoMsg = "검색결과가 없습니다."
              }, 500); 
            }       
          } else {
            EventBus.$emit("onShowMsg", true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg", true,""+err);
        });
    },

    // 생년월일 유효성검사
    CheckBirth() {
      var birth = this.editedItem.cBirth
      var year = this.editedItem.cBirth.substring(0,4)
      var month = this.editedItem.cBirth.substring(4,6)
      var day = this.editedItem.cBirth.substring(6,8)
      // this.bBirthcheck = true;
      // var check1 = /^(?=.*[0-9]).{6}$/.test(birth);              //숫자 (6자리)
      var check1 = /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/.test(birth);

      if(!(check1)){
        EventBus.$emit("onShowMsgBox","생년월일 형식이 잘못 되었습니다", "생년월일을 (년도)(월)(일) 양식에 맞춰 입력해주세요.");
        return false;
      }
      if(month <1 || month >12){
        EventBus.$emit("onShowMsgBox","생년월일 형식이 잘못 되었습니다.", "가운데 2자리를 확인해 주세요.");
                
      }
      if(day <1 || day >31){
        EventBus.$emit("onShowMsgBox","생년월일 형식이 잘못 되었습니다.", "마지막 2자리를 확인해 주세요.");
        return false;
      }
      if((month==4 || month==6 || month==9 || month==11) && day==31){
        EventBus.$emit("onShowMsgBox","생년월일 형식이 잘못 되었습니다.", "해당 년도의 2월은 28일까지 있습니다.");
        return false;
      }
      if(month==2){
        var isleap = (year % 4 == 0 && (year % 100 != 0 || year % 400 == 0));  //윤년(4로 나눠지는해, 4,100으로 나눠지는해는 아님, 4,100,400나눠지는 해)
        if (day > 28 && !isleap) {
          EventBus.$emit("onShowMsgBox","생년월일 형식이 잘못 되었습니다.", "해당 년도의 2월은 28일까지 있습니다.");
          return false;
        } else if (day > 29 && isleap) {
          EventBus.$emit("onShowMsgBox","생년월일 형식이 잘못 되었습니다.", "해당 년도의 2월은 29일까지 있습니다.");
          return false;
        }
      }
      return true;
    },

    // 다이올로그 취소시 닫음 
    Close() {      
      this.bDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.Records1 = [];
        this.Records3 = [];
        this.editedIndex = -1;
      }, 300);
    },

    // 다이올로그 검색어 초기화
    Clear() {
      this.editedItem = Object.assign({}, this.defaultItem);
    },


    // 협력업체 찾기 다이올로그 띄우기
    SearchCorp() {
      this.$refs.SearchCorpRef.Open("Search",this.editedItem.cCorpNm);
    },
    
    // 협력업체 찾기 결과 받아오기
    GetCorpInfo(Data) {
      if (Data.cCorpNmKor != undefined || Data.cCorpNmEng != undefined) {
        if (Data.cLocal == "Y") {
          this.editedItem.cCorpNm = Data.cCorpNmKor
        } else {
          this.editedItem.cCorpNm = Data.cCorpNmEng
        }

        this.editedItem.cCorpId = Data.cCorpId
        setTimeout(() => {
          
          if (this.iModel == 0) {
            this.$refs.cCustomNmRef1.focus()
          } else {
            this.$refs.cCustomNmRef2.focus()
          }
        }, 10);
      }
    },
  }
};
</script>

<style scoped>

</style>
